module.exports = require("core-js/library/fn/date/now");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/date/now.js
// module id = 245
// module chunks = 0 1